module.exports = __webpack_public_path__ + "img/loan_status_review.4fa9427a.webp";